
export const isSocialSecurityNumberValid = (value: string): boolean => {
    const SSN_REGEX_FROM_BACKEND = /^(?!(.)\1{8})(?!078051120)(?!219099999)(?!123456789)((?!000)(?!666)(?!9)\d{3}(?!00)\d{2}(?!0000)\d{4})$/;
    return SSN_REGEX_FROM_BACKEND.test(value);
}

export const stripSocialSecurityNumberFormatting = (value: string): string => {
    if (!value) return '';

    return value.replace(/\D/g, '');
};



// WEBPACK FOOTER //
// ./src/utils/pid-validation.ts